/* RESPONSIBLE TEAM: team-frontend-tech */

/**
 * Downloads a file from a fetch Response using blob URL pattern.
 * Extracts filename from Content-Disposition header if present.
 * Works around Safari 401 issues with form-based POST downloads.
 */
export async function downloadFromResponse(
  response: Response,
  defaultFilename = 'download',
): Promise<void> {
  let blob = await response.blob();

  // eslint-disable-next-line @intercom/intercom/no-bare-strings -- HTTP header name
  let contentDisposition = response.headers.get('Content-Disposition');
  let filename = defaultFilename;
  if (contentDisposition) {
    let match = contentDisposition.match(/filename="?([^";\n]+)"?/);
    if (match) {
      filename = match[1];
    }
  }

  let downloadUrl = URL.createObjectURL(blob);
  let link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(downloadUrl);
}
